import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { useHistory } from 'react-router-dom'
// styles
import './Create.css'

// hooks
import { useCollection } from '../../Hooks/useCollection'
import { timestamp } from '../../Firebase/Config'
import { useAuthContext } from '../../Hooks/useAuthContext'
import { useFireStore } from '../../Hooks/useFireStore'


// categories
const categories = [
  { value: 'development', label: 'Development'},
  { value: 'design', label: 'Design'},
  { value: 'sales', label: 'Sales'},
  { value: 'marketing', label: 'Marketing'},
  { value: 'finance', label: 'Finance'},
]


export default function Create() {
  // form fields
  const [name, setName] = useState('')
  const [details, setDetails] = useState('')
  const [dueDate, setDueDate] = useState('')
  const [category, setCategory] = useState('')
  const [assignedUsers, setAssignedUsers] = useState([])
  const [error, setFormError] = useState(null)

  const [users, setUsers] = useState([])
  const { document } = useCollection('users')
  const { user } = useAuthContext();
  const { addDocument, response } = useFireStore('projects')
  const history = useHistory();




  useEffect(() => {
    if(document){
      const options = document.map (user => {
        return {value: user , label: user.displayName}
      })
      setUsers(options)
    }
    
  }, [document])
  



  // handle submit
  const handleSubmit = async(e) => {
    e.preventDefault()
    // validations
    setFormError(null);

    if(!category ){
      setFormError('Please select a project category');
      return;
    }
    if(assignedUsers.length < 1){
      setFormError('Please assign atleast 1 user to this project');
      return;
    }

    // created by
    const createdBy =  {
      displayName: user.displayName,
      photoURL: user.photoURL,
      id: user.uid
    }

    // assigned users list
    const assignedUsersList = assignedUsers.map((u) => {
      return {
        displayName: u.value.displayName,
        photoURL: u.value.photoURL,
        id: u.value.id
      }
    })

    // create project
    const project = {
      name,
      details,
      category: category.value,
      dueDate: timestamp.fromDate(new Date(dueDate)),
      comments: [],
      createdBy,
      assignedUsersList
    }

    // saving project to firestore
    await addDocument(project)
    if(!response.error){
      history.push('/')
    }

  }

  return (
    <div className="create-form">
      <h2 className="page-title">Create a new project</h2>
      <form onSubmit={handleSubmit} >
        <label >
          <span>Name:</span>
          <input required type="text" value={name} onChange={ (e) => setName(e.target.value) }/>
        </label>
        <label >
          <span>Details:</span>
          <textarea required type="text" value={details} onChange={ (e) => setDetails(e.target.value) }></textarea>
        </label>
        <label >
          <span>Due Date:</span>
          <input required type="date" value={dueDate} onChange={ (e) => setDueDate(e.target.value) }/>
        </label>
        <label>
          <span>Project Category</span>
          {/* cetegory select */}
          <Select 
            options={categories}
            onChange={(option)=> setCategory(option)}
          />
        </label>
        <label>
          <span>Assigned To:</span>
          <Select 
            options={users} 
            onChange={(option) => setAssignedUsers(option)}
            isMulti />
        </label>
        <button className='btn'>Submit</button>
        {error && <p className='error'>{error}</p>}
      </form>
    </div>
  )
}
